export function getPrintKkmServerChannel (filialId) {
    return `print.kkm_server.${filialId}`
}

export function getFilialChannel (filialId) {
    return `filial.${filialId}`
}

export function getUserChannel (userId) {
  return `events.user.${userId}`
}

export function getPaymentAccountChannel (paymentAccountId) {
  return `billing.payment-account.${paymentAccountId}`
}

export function getOrderChannel (orderId) {
  return `orders.id.${orderId}`
}

export function getOrdersChannel (isCallCenter, filialId) {
  return isCallCenter
    ? 'orders.filial.call_center'
    : `orders.filial.${filialId}`
}
